<template>
  <div>
    <el-tabs v-model="propertyTab">
      <el-tab-pane label="Status" name="status">
        <!-- Status Chart -->
        <v-chart :forceFit="true" renderer="svg" :height="graphHeight" :data="ticketCountByStatus" :scale="graphScale">
          <v-tooltip />
          <v-axis />
          <v-bar position="status*count" />
        </v-chart>
        <!-- / Status Chart -->

        <!-- Status Table -->
        <table class="table mb-0 table-centered">
          <thead class="thead-light">
            <tr>
              <th>Status</th>
              <th>Number of Tickets</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="status in ticketCountByStatus">
              <th scope="row">{{ status.status }}</th>
              <td>{{ status.count }}</td>
            </tr>
          </tbody>
        </table>
        <!-- / Status Table -->
      </el-tab-pane>
      <el-tab-pane :lazy="true" label="Priority" name="priority">
        <!-- Priority Chart -->
        <v-chart :forceFit="true" renderer="svg" :height="graphHeight" :data="ticketCountByPriority" :scale="graphScale">
          <v-tooltip />
          <v-axis />
          <v-bar position="priority*count" />
        </v-chart>
        <!-- / Priority Chart -->

        <!-- Priority Table -->
        <table class="table mb-0 table-centered">
          <thead class="thead-light">
            <tr>
              <th>Priority</th>
              <th>Number of Tickets</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="priority in ticketCountByPriority">
              <th scope="row">{{ priority.priority }}</th>
              <td>{{ priority.count }}</td>
            </tr>
          </tbody>
        </table>
        <!-- / Priority Table -->
      </el-tab-pane>
      <el-tab-pane :lazy="true" label="Difficulty" name="difficulty">
        <!-- Difficulty Chart -->
        <v-chart :forceFit="true" renderer="svg" :height="graphHeight" :data="ticketCountByDifficulty"
          :scale="graphScale">
          <v-tooltip />
          <v-axis />
          <v-bar position="difficulty*count" />
        </v-chart>
        <!-- / Difficulty Chart -->

        <!-- Difficulty Table -->
        <table class="table mb-0 table-centered">
          <thead class="thead-light">
            <tr>
              <th>Difficulty</th>
              <th>Number of Tickets</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="difficulty in ticketCountByDifficulty">
              <th scope="row">{{ difficulty.difficulty }}</th>
              <td>{{ difficulty.count }}</td>
            </tr>
          </tbody>
        </table>
        <!-- / Difficulty Table -->
      </el-tab-pane>
      <el-tab-pane :lazy="true" label="Time Created">

        <!-- Timezone -->
        <div class="mb-5">
          <div class="alert alert-primary mb-0">
            Times being showed in the timezone: <strong>{{ timezone }}</strong>
          </div>
        </div>
        <!-- / Timezone -->

        <!-- Time Created Chart -->
        <v-chart :forceFit="true" renderer="svg" :height="graphHeight" :data="ticketCountByHour" :scale="graphScale">
          <v-tooltip />
          <v-axis />
          <v-bar position="hourFormatted*count" />
        </v-chart>
        <!-- / Time Created Chart -->

        <!-- Time Created Table -->
        <table class="table mb-0 table-centered">
          <thead class="thead-light">
            <tr>
              <th>Hour Created</th>
              <th>Number of Tickets</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="hour in ticketCountByHour">
              <th scope="row">{{ hour.label }}</th>
              <td>{{ hour.count }}</td>
            </tr>
          </tbody>
        </table>
        <!-- / Time Created Table -->

      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Tickets from "../../../../../mixins/Tickets";

export default {
  name: "TicketAnalytics",
  mixins: [Tickets],
  data() {
    return {
      propertyTab: 'status',

      graphHeight: 350,
      graphScale: [{
        dataKey: 'count'
      }],

      updateKey: 1
    }
  },
  computed: {
    ...mapGetters('reportEditor', {
      results: 'results',
      agents: 'agents'
    }),

    timezone() {
      return window.itgTimezone;
    },

    ticketCountByStatus() {
      let counts = [];
      _.each(this.ticketStatusDropdownOptions, status => {
        counts.push({
          status: status.label,
          count: this.determineNumberOfTicketsWhereStatusIs(status.value)
        });
      });
      return counts;
    },

    ticketCountByPriority() {
      let counts = [];
      _.each(this.ticketPriorityDropdownOptions, priority => {
        counts.push({
          priority: priority.label,
          count: this.determineNumberOfTicketsWherePriorityIs(priority.value)
        });
      });
      return counts;
    },

    ticketCountByDifficulty() {
      let counts = [];
      _.each(this.ticketDifficultyDropdownOptions, difficulty => {
        counts.push({
          difficulty: difficulty.label,
          count: this.determineNumberOfTicketsWhereDifficultyIs(difficulty.value)
        });
      });
      return counts;
    },

    hourBins() {
      let bins = [];
      for (let i = 0; i < 24; i++) {
        bins.push(i);
      }
      return bins;
    },

    ticketCountByHour() {
      let counts = [];
      _.each(this.hourBins, hour => {
        counts.push({
          hour: hour,
          hourFormatted: this.formatHour(hour),
          label: this.formatHour(hour) + ' - ' + (this.formatHour(hour + 1)),
          count: this.determineNumberOfTicketsWhereHourIs(hour)
        });
      });
      return counts;
    }
  },
  methods: {
    formatHour(hour) {
      if (hour > 12) {
        return (hour - 12) + ' PM';
      } else {
        return hour + ' AM';
      }
    },

    determineNumberOfTicketsWhereStatusIs(status) {
      return _.filter(this.results, ticket => {
        return ticket.status === status;
      }).length;
    },

    determineNumberOfTicketsWhereHourIs(hour) {
      return _.filter(this.results, ticket => {
        return moment.utc(ticket.created_at).tz(window.itgTimezone).hour() === hour;
      }).length;
    },

    determineNumberOfTicketsWherePriorityIs(priority) {
      return _.filter(this.results, ticket => {
        return ticket.priority === priority;
      }).length;
    },

    determineNumberOfTicketsWhereDifficultyIs(difficulty) {
      return _.filter(this.results, ticket => {
        return ticket.difficulty === difficulty;
      }).length;
    },

    incrementUpdateKey() {
      this.updateKey += 1;
    }
  }
}
</script>

<style scoped></style>